"use client";

import { MdLink, MdSend, MdMoreVert } from "react-icons/md";

import { PhoneLayout } from "@/features/previews/layouts/PhoneLayout";
import { useEmailData } from "./hooks";
import type { QRProps } from "@/contexts/QREditorContext/types";
import { Divider } from "@/components/Divider";

import "./EmailTemplate.scss";

export const EmailTemplate = (props: QRProps<"email">) => {
  const { data, isInitialPreview, email, subject, message } = useEmailData(props);

  if (!data) {
    return null;
  }

  return (
    <>
      <div className="email-template__header">
        <div className="email-template__header-title">Email</div>
        <div className="email-template__header-icons">
          <MdLink size={24} />
          <MdSend size={24} />
          <MdMoreVert size={24} />
        </div>
      </div>
      <PhoneLayout
        page="email"
        dataQA="preview-email-container"
        backgroundColor={"#4848f0"}
        isInitPreview={isInitialPreview}
      >
        <div className="email-template__container">
          <div className="email-template__row">
            <div className="email-template__label">Address</div>
            <div className="email-template__email">{email}</div>
          </div>

          <Divider spacing={0} />

          <div className="email-template__row">
            <div className="email-template__label">Subject</div>
            <div className="email-template__subject">{subject}</div>
          </div>

          <Divider spacing={0} />

          <div className="email-template__column">
            <div className="email-template__label">Message</div>
            <div className="email-template__message">{message}</div>
          </div>
        </div>
      </PhoneLayout>
    </>
  );
};
